<template>
  <svg class="xds:icon" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.729 4.87842L5.8543 5.99999L6.99995 4.87842"
      stroke="currentColor"
      stroke-width="0.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.85449 5.8V2"
      stroke="currentColor"
      stroke-width="0.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.64473 4.94424C3.43292 5.31228 3.08873 5.56707 2.71806 5.56707C2.08264 5.56707 1.57959 4.88762 1.57959 4.0383V4.00999V4.0383C1.57959 3.18898 2.08264 2.50952 2.71806 2.50952C3.08873 2.50952 3.43292 2.76432 3.64473 3.13236"
      stroke="currentColor"
      stroke-width="0.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1 4.378H2.56562"
      stroke="currentColor"
      stroke-width="0.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1 3.7552H2.56562"
      stroke="currentColor"
      stroke-width="0.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
